export enum CustomStatusCodes {
  IncorrectProvider = 419,
  SessionExpired = 420,
  IncompleteOAuthInfo = 421,
  IncorrectOAuthAccount = 422,
}
